import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "Breadcrumbs",
    component: () => (__SERVER__ ? require("./breadcrumbs-view") : import("./breadcrumbs-view"))
});

export default definition;
